export default __webpack_public_path__ + "static/media/white-multi-knob.b1fae29e.png";